import { render } from "./icon-trash.vue?vue&type=template&id=4f9cf67e"
import script from "./icon-trash.vue?vue&type=script&lang=js"
export * from "./icon-trash.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__